
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
    >
      <base-card with_divider v-if="ready">
        <template slot="title">
          <span class="text-capitalize">
            {{ is_edit && $t('tasks.edit') || is_new && $t('tasks.new')}}
          </span>
          <span class="ml-2">
            de 
            "{{ taskable_name }}"
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="taskForm">
            <v-text-field 
              :placeholder="$t('tasks.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="local_task.name" dense
              :rules="required"
              :disabled="!$can('update', new entities.Stage(local_task.use_type))"
            ></v-text-field>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-0 mr-2"> {{ $t('tasks.subtasks.subtasks') }}: </b>
              <v-btn color="accent" small class="black--text elevation-0 text-capitalize" rounded 
                @click="addSubtask()"
                :disabled="!$can('update', new entities.Stage(local_task.use_type))"
              >
                <v-icon left small >mdi-plus</v-icon>
                {{ $t('tasks.subtasks.add_new') }}
              </v-btn>
            </v-row>

            <!-- <v-row align="center" class="pa-3"> -->
                <draggable v-model="local_task.subtasks" @change="reorder" @start="handleDragStart" @end="handleDragStop" draggable=".bacon" handle=".handle">
                  <transition-group type="transition" :name="!is_dragging ? 'flip-list' : null">

              <v-col class="pa-0 mb-2 bacon" cols="12" v-for="(subtask, idx) in local_task.subtasks" :key=" subtask.ref">
                <v-row align="center" class="pa-3">
                  <v-col cols="11" class="pa-0" align='right'>
                    <base-info-card with_spacer @click="openSubtask(subtask, idx)">
                      <template slot="icon">
                        <v-icon ref="icon_draggable" class="handle" :style="{cursor: is_dragging? 'grabbing':'grab'}">mdi-drag</v-icon>
                        <span :class="['mr-3', any_subtask_with_same_positions && subtasks_with_same_positions[subtask.position] > 1? 'red--text' : null]">
                          # {{ subtask.position }}
                        </span>
                      </template>
                      <template slot="text">
                        <span style="max-width: 35vw;" class="black--text title text-truncate"> 
                          {{ subtask.name }}
                        </span>
                      </template>
                      <template slot="last">
                        <div></div>
                        <v-tooltip top v-if="false ">
                          <template v-slot:activator="{on}">
                            <v-chip  class="my-1 my-sm-0" v-on="on">
                              <v-avatar left>
                                <v-icon>mdi-calendar</v-icon>
                              </v-avatar>
                              {{ subtask.default_duration_days }} {{$tc('day', 2).toLowerCase()}}
                            </v-chip>
                          </template>
                          {{ $t('tasks.subtasks.expected_duration') }}
                        </v-tooltip>
                      </template>
                    </base-info-card>
                  </v-col>
                  <v-btn icon color="error" @click="removeSubtask(idx)"
                    :disabled="!$can('update', new entities.Stage(local_task.use_type))"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
                  </transition-group>
            </draggable>
          <!-- </v-row> -->
          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancelTask" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="saveTask" text
            :disabled="!$can('update', new entities.Stage(local_task.use_type))"
          >
            {{ $t('save') }}
          </v-btn>
        </template>
      </base-card>
    </v-dialog>

    <dialog-one-subtask v-if="dialog_subtask" :is_new="!is_editing_subtask" :is_edit="is_editing_subtask" :subtask="editing_subtask" 
      :task_id="is_edit && task.id || null" :position="sub_position"
      @cancel="handleCancelSubask"
      @done="handleDoneSubtask"
    ></dialog-one-subtask>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import request_error_catch from '@/mixins/request_error_catch'
import draggable_helpers from '@/mixins/draggable_helpers'
import Api from '@/api/index';
import DialogOneSubtask from './DialogOneSubtask.vue';
import entities from '@/utils/entities';

export default {
  name: 'DialogOneTask',
  mixins: [ validations, draggable_helpers, request_error_catch ],
  components: {
    DialogOneSubtask,
    //ComponentName: () => import(''),
  },
  props: {
    taskable_type: {
      type: String,
    },
    taskable_name: {
      type: String,
    },
    taskable_id: {
      type: [String, Number],
    },
    is_new: {
      type: Boolean,
      default: false,
    },
    is_edit: {
      type: Boolean,
      default: false,
    },
    task: {
      type: Object,
    },
    position: {
      type: [String, Number],
    }
  },
  data() {
    return {
      dialog: true,
      ready: false,

      loading: false,
      entities: entities,


      local_task: {},

      default_template_task: {
        name: null,
        status: 'active',
        due_at: null,
        done_at: null,
        user_ids: [],
        expected_duration: 2, 
        position: null,
        subtasks: [],
      },
      default_subtask: {
        ref: null,
        name: null,
        due_at: null,
        done_at: null,
        position: null,
      },

      dialog_subtask: false,
      is_editing_subtask: false,
      editing_subtask: null,
      sub_position: null,

      any_subtask_with_same_positions: false,
      subtasks_with_same_positions: {},
    }
  }, 

  methods: {
    setupLocalTask() {
      this.ready = false
      if (this.is_edit && this.task){
        const { json_attributes: {subtasks, ...other}, ...tk} = this.task
        this.local_task = {
          ...tk,
          // subtasks: [...new Set(subtasks)],
          subtasks: [...(subtasks)],
          ...other,
          position: this.task.idx + 1
        }
      } else {
        this.local_task = {
          ...this.default_template_task,
          taskable_type: this.taskable_type,
          taskable_id: this.taskable_id,
          position: this.position,
          subtasks: []
        }
      }
      this.ready = true
    },
    openSubtask(subtask, idx){
      if (this.$can('edit', new entities.Stage(this.local_task.use_type))){
        this.editing_subtask = {...subtask, idx}
        this.sub_position = idx
        this.dialog_subtask = true
        this.is_editing_subtask = true
      } else {
        this.addNotification({type: 'error', msg: 'Sem permissão para essa ação.'})
      }
      // this.local_task.subtasks.push({...this.default_subtask, ref: Math.random()})
    },
    addSubtask(){
      this.dialog_subtask = true
      this.is_editing_subtask = false
      this.editing_subtask = null
      this.sub_position = this.local_task.subtasks.length + 1
      // this.local_task.subtasks.push({...this.default_subtask, ref: Math.random()})
    },
    handleCancelSubask(e){
      this.dialog_subtask = false
      this.is_editing_subtask = false
      this.editing_subtask = null
    },
    handleDoneSubtask(e){
      const {idx, ...stage} = e
      if (idx > -1){
        this.local_task.subtasks.splice(idx, 1, {...stage, ref: Math.random()})
      } else {
        this.local_task.subtasks.push({...stage, ref: Math.random()})
      }
      this.local_task.subtasks = this.local_task.subtasks.sort((a,b) => Number(a.position) - Number(b.position)); // b - a for reverse sort)
      this.handleCancelSubask()
      // this.local_task.subtasks.push({...this.default_subtask, ref: Math.random()})
    },
    reorder(){
      this.local_task.subtasks = this.local_task.subtasks.map((t, idx)=> {return {...t, position: idx + 1}})
    },
    removeSubtask(idx){
      this.local_task.subtasks.splice(idx, 1)
      this.reorder()
    },
    cancelTask(){
      this.$emit('cancel')
    },
    saveTask(){
      if (this.$refs.taskForm.validate()){
        this.loading = true
        const {json_attributes, ...task} = this.local_task
        let obj = {
          ...task,
          use_type: 'template'
        }
        const ACTION = this.is_edit ? 'update' : 'create'
        Api.Task[ACTION](obj).then(r=> {
          this.$emit('done', obj)
        }).catch(err=> {
          console.log({err});
          this.catch_error(err)
        }).finally(()=> this.loading = false)
      }
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.setupLocalTask();
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.cancelTask()
      }
    }
  },
}
</script>

<style scoped>

</style>